"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Component for Metaform submit field
 */
class MetaformSubmitFieldComponent extends react_1.default.Component {
    /**
     * Constructor
     *
     * @param props component props
     */
    constructor(props) {
        super(props);
        /**
         * Event handler for field input change
         *
         * @param event event
         */
        this.onClick = (event) => {
            this.props.onClick(this.props.field);
        };
        this.state = {};
    }
    /**
     * Component render method
     */
    render() {
        const { field, validationErrors } = this.props;
        if (!field.name) {
            return null;
        }
        const hasValidationErrors = Object.keys(validationErrors).length > 0;
        const disabled = hasValidationErrors || this.props.formReadOnly || this.props.field.readonly;
        const style = {};
        if (disabled) {
            style["background"] = "#aaa";
        }
        return (react_1.default.createElement("input", { type: "submit", style: style, disabled: disabled, value: this.props.field.text, onClick: this.onClick }));
    }
}
exports.MetaformSubmitFieldComponent = MetaformSubmitFieldComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1TdWJtaXRGaWVsZENvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9NZXRhZm9ybVN1Ym1pdEZpZWxkQ29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLGtEQUE2QztBQXdCN0M7O0dBRUc7QUFDSCxNQUFhLDRCQUE2QixTQUFRLGVBQUssQ0FBQyxTQUF1QjtJQUU3RTs7OztPQUlHO0lBQ0gsWUFBWSxLQUFZO1FBQ3RCLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQztRQW9DZjs7OztXQUlHO1FBQ0ssWUFBTyxHQUFHLENBQUMsS0FBcUQsRUFBRSxFQUFFO1lBQzFFLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDdkMsQ0FBQyxDQUFBO1FBekNDLElBQUksQ0FBQyxLQUFLLEdBQUcsRUFFWixDQUFDO0lBQ0osQ0FBQztJQUVEOztPQUVHO0lBQ0ksTUFBTTtRQUNYLE1BQU0sRUFBRSxLQUFLLEVBQUUsZ0JBQWdCLEVBQUUsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO1FBRS9DLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFO1lBQ2YsT0FBTyxJQUFJLENBQUM7U0FDYjtRQUVELE1BQU0sbUJBQW1CLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7UUFDckUsTUFBTSxRQUFRLEdBQUcsbUJBQW1CLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxZQUFZLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDO1FBQzdGLE1BQU0sS0FBSyxHQUFrQixFQUFFLENBQUM7UUFFaEMsSUFBSSxRQUFRLEVBQUU7WUFDWixLQUFLLENBQUMsWUFBWSxDQUFDLEdBQUcsTUFBTSxDQUFDO1NBQzlCO1FBRUQsT0FBTyxDQUNMLHlDQUNFLElBQUksRUFBQyxRQUFRLEVBQ2IsS0FBSyxFQUFHLEtBQUssRUFDYixRQUFRLEVBQUcsUUFBUSxFQUNuQixLQUFLLEVBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUM3QixPQUFPLEVBQUcsSUFBSSxDQUFDLE9BQU8sR0FDdEIsQ0FDSCxDQUFDO0lBQ0osQ0FBQztDQVdGO0FBckRELG9FQXFEQyJ9